import {
  Box,
  Typography,
  Button,
  TextField,
  Alert,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {
  LocalizationProvider,
  DatePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/es";
import dayjs from "dayjs";

import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";

import { useEffect, useCallback, useState } from "react";

import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import Header from "../../components/Header";
import { getUAsignacionHistory } from "../../services/uniformes.services";
import { getApiImagen } from "../../utils/getApiBaseUrl";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
const buildColumnsHistorialAsignacion = ({ rows }) => {
  return [
    {
      field: "id_asignacion",
      headerName: "ID",
      width: 70,

      renderCell: (params) => (
        <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
          #{params.value}
        </Typography>
      ),
    },

    {
      field: "descripcion",
      headerName: "Descripción",
      flex: 0.6,

      renderCell: (params) => (
        <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
          {params.value}
        </Typography>
      ),
    },

    {
      field: "talla",
      headerName: "Talla",
      width: 90,
    },

    {
      field: "funcionario",
      headerName: "Funcionario",
      flex: 0.8,

      renderCell: (params) => (
        <Typography
          sx={{
            fontSize: "12px",
            color: "text.primary",
            fontWeight: 500,
          }}
        >
          {params.value || "—"}
        </Typography>
      ),
    },

    {
      field: "entregado",
      headerName: "Entregado por",
      flex: 0.8,

      renderCell: (params) => (
        <Typography
          sx={{
            fontSize: "12px",
            color: "text.secondary",
          }}
        >
          {params.value || "—"}
        </Typography>
      ),
    },

    {
      field: "estado_stock",
      headerName: "Estado stock",
      width: 160,

      renderCell: (params) => {
        const estado = params.value || "SIN ESTADO";

        let color = "#378ADD";
        let bg = "#E6F1FB";

        if (estado === "NUEVO") {
          color = "#b5a300";
          bg = "rgba(206,220,0,0.12)";
        }

        if (estado === "DEVUELTO") {
          color = "#2e7d32";
          bg = "rgba(46,125,50,0.12)";
        }

        if (
          estado === "PERDIDA" ||
          estado === "PÉRDIDA"
        ) {
          color = "#ef6c00";
          bg = "rgba(239,108,0,0.12)";
        }

        if (estado === "DE BAJA") {
          color = "#d32f2f";
          bg = "rgba(211,47,47,0.12)";
        }

        if (estado === "EN USO") {
          color = "#3e4396";
          bg = "rgba(62,67,150,0.12)";
        }

        return (
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 0.75,
              background: bg,
              border: `1px solid ${color}33`,
              borderRadius: "20px",
              px: 1.25,
              py: 0.25,
            }}
          >
            <Box
              sx={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: color,
              }}
            />

            <Typography
              sx={{
                fontSize: "11px",
                fontWeight: 700,
                color,
                letterSpacing: "0.04em",
              }}
            >
              {estado}
            </Typography>
          </Box>
        );
      },
    },

    {
      field: "estado_entrega",
      headerName: "Estado entrega",
      width: 160,

      renderCell: (params) => (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.75,
            background: "rgba(99,179,237,0.12)",
            border: "1px solid rgba(99,179,237,0.3)",
            borderRadius: "20px",
            px: 1.25,
            py: 0.25,
          }}
        >
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              background: "#63b3ed",
            }}
          />

          <Typography
            sx={{
              fontSize: "11px",
              fontWeight: 700,
              color: "#63b3ed",
            }}
          >
            {params.value || "—"}
          </Typography>
        </Box>
      ),
    },

    {
      field: "estado_devolucion",
      headerName: "Estado devolución",
      width: 170,

      renderCell: (params) => (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.75,
            background: "rgba(76,175,80,0.12)",
            border: "1px solid rgba(76,175,80,0.3)",
            borderRadius: "20px",
            px: 1.25,
            py: 0.25,
          }}
        >
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              background: "#4caf50",
            }}
          />

          <Typography
            sx={{
              fontSize: "11px",
              fontWeight: 700,
              color: "#4caf50",
            }}
          >
            {params.value || "—"}
          </Typography>
        </Box>
      ),
    },

    {
      field: "fecha_entrega",
      headerName: "Fecha entrega",
      width: 150,

      renderCell: (params) => (
        <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
          {params.value
            ? new Date(params.value).toLocaleDateString("es-PY")
            : "—"}
        </Typography>
      ),
    },

    {
      field: "fecha_devolucion",
      headerName: "Fecha devolución",
      width: 160,

      renderCell: (params) => (
        <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
          {params.value
            ? new Date(params.value).toLocaleDateString("es-PY")
            : "—"}
        </Typography>
      ),
    },

    {
      field: "obs",
      headerName: "Observación",
      flex: 1,

      renderCell: (params) => (
        <Typography
          sx={{
            fontSize: "12px",
            color: "#ef6c00",
            fontStyle: "italic",
          }}
        >
          {params.value || "—"}
        </Typography>
      ),
    },

    {
      field: "img",
      headerName: "Imagen",
      flex: 0.7,

      renderCell: (params) => (
        <img
          src={`${getApiImagen()}${params.value}`}
          alt="Uniforme"
          style={{
            width: "150px",
            height: "100px",
            objectFit: "cover",
            borderRadius: "10px",
          }}
        />
      ),
    },
  ];
};


const HistorialAsignacionU = () => {
  const hoy = dayjs();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const [fechaInicio, setFechaInicio] = useState(hoy);
  const [fechaFin, setFechaFin] = useState(hoy);

  const [errorFecha, setErrorFecha] = useState("");

  const fetchData = useCallback(async () => {
    if (fechaInicio.isAfter(fechaFin)) {
      setErrorFecha(
        "La fecha inicio no puede ser mayor a la fecha fin",
      );

      setRows([]);
      return;
    }

    setErrorFecha("");

    try {
      setLoading(true);

      const data = await getUAsignacionHistory({
        fecha_inicio: fechaInicio.format("YYYY-MM-DD"),
        fecha_fin: fechaFin.format("YYYY-MM-DD"),
      });

      setRows(data || []);
    } catch (err) {
      console.error(err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [fechaInicio, fechaFin]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const columns = buildColumnsHistorialAsignacion({ rows });
      const exportarExcel = async () => {
  const workbook = new ExcelJS.Workbook();

  // 🔹 HOJA PRINCIPAL
  const sheet = workbook.addWorksheet("Stock Minimos");

sheet.columns = [
  { header: "ID", key: "id_asignacion", width: 10 },
  { header: "Descripción", key: "descripcion", width: 25 },
  { header: "Talla", key: "talla", width: 10 },
  { header: "Funcionario", key: "funcionario", width: 35 },
  { header: "Entregado por", key: "entregado", width: 35 },
  { header: "Estado Stock", key: "estado_stock", width: 20 },
  { header: "Estado Entrega", key: "estado_entrega", width: 20 },
  { header: "Estado Devolución", key: "estado_devolucion", width: 22 },
  { header: "Fecha Entrega", key: "fecha_entrega", width: 18 },
  { header: "Fecha Devolución", key: "fecha_devolucion", width: 18 },
  { header: "Observación", key: "obs", width: 40 },
];

rows.forEach((r) => {
  sheet.addRow({
    id_asignacion: r.id_asignacion,
    descripcion: r.descripcion,
    talla: r.talla,
    funcionario: r.funcionario,
    entregado: r.entregado,
    estado_stock: r.estado_stock,
    estado_entrega: r.estado_entrega,
    estado_devolucion: r.estado_devolucion,
    fecha_entrega: r.fecha_entrega
      ? new Date(r.fecha_entrega).toLocaleDateString("es-PY")
      : "",
    fecha_devolucion: r.fecha_devolucion
      ? new Date(r.fecha_devolucion).toLocaleDateString("es-PY")
      : "",
    obs: r.obs,
  });
});

  // 🔹 ESTILO CABECERA
  sheet.getRow(1).eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF3E4396" },
    };

    cell.font = {
      color: { argb: "FFFFFFFF" },
      bold: true,
    };

    cell.alignment = {
      vertical: "middle",
      horizontal: "left",
    };
  });

  // 🔹 BORDES Y AJUSTES
  sheet.eachRow((row) => {
    row.eachCell((cell) => {
      cell.border = {
        top: { style: "thin", color: { argb: "FFE0E0E0" } },
        left: { style: "thin", color: { argb: "FFE0E0E0" } },
        bottom: { style: "thin", color: { argb: "FFE0E0E0" } },
        right: { style: "thin", color: { argb: "FFE0E0E0" } },
      };
    });
  });

  // 💾 DESCARGA
  const buffer = await workbook.xlsx.writeBuffer();

  const fileData = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(fileData, "Historial_Uniformes.xlsx");
};
 const exportarPDF = () => {
  const doc = new jsPDF("landscape");

  // 🔹 TÍTULO
  doc.setFontSize(18);

  doc.text("Historial de Uniformes", 14, 15);

  doc.setFontSize(11);

  doc.text(
    `Rango: ${fechaInicio.format("DD/MM/YYYY")} - ${fechaFin.format(
      "DD/MM/YYYY",
    )}`,
    14,
    24,
  );

  // 🔹 TABLA
autoTable(doc, {
  startY: 32,
  head: [[
  "ID",
  "Descripción",
  "Talla",
  "Funcionario",
  "Entregado por",
  "Estado Stock",
  "Estado Entrega",
  "Estado Dev.",
  "F. Entrega",
  "F. Devolución",
  "Obs"
]],
body: rows.map((r) => [
  r.id_asignacion,
  r.descripcion,
  r.talla,
  r.funcionario,
  r.entregado,
  r.estado_stock,
  r.estado_entrega,
  r.estado_devolucion,
  r.fecha_entrega
    ? new Date(r.fecha_entrega).toLocaleDateString("es-PY")
    : "",
  r.fecha_devolucion
    ? new Date(r.fecha_devolucion).toLocaleDateString("es-PY")
    : "",
  r.obs || "",
]),

  styles: {
    fontSize: 6,
    cellPadding: 2,
  },

  columnStyles: {
    10: { cellWidth: 35 }, // observación
  },

  headStyles: {
    fillColor: [62, 67, 150],
    textColor: [255, 255, 255],
    fontStyle: "bold",
  },
});

  doc.save("Historial_Uniformes.pdf");
};
  return (
    <Box m="20px">
      <Header
        title="Historial"
        subtitle="Historial de Uniformes Entregados"
      />

      {/* FILTROS */}
      <Box
        sx={{
          display: "flex",
          gap: 2,
          mb: 3,
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale="es"
        >
          <DatePicker
            label="Fecha inicio"
            value={fechaInicio}
            format="DD/MM/YYYY"
            onChange={(value) => {
              if (!value) return;

              setFechaInicio(value);

              // evita automáticamente error visual
              if (value.isAfter(fechaFin)) {
                setFechaFin(value);
              }
            }}
          />

          <DatePicker
            label="Fecha fin"
            value={fechaFin}
            minDate={fechaInicio}
            format="DD/MM/YYYY"
            onChange={(value) => {
              if (!value) return;

              setFechaFin(value);
            }}
          />
        </LocalizationProvider>
              {/* PDF */}
  <Button
    onClick={exportarPDF}
    disabled={!rows.length || !!errorFecha}
    sx={{
      border: "1px solid #e53935",
      color: "#e53935",
      borderRadius: "10px",
      px: 2,
      py: 1,
      textTransform: "none",
      fontWeight: 600,

      "&:hover": {
        background: "rgba(229,57,53,0.08)",
      },
    }}
  >
    <img
      src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
      alt="PDF Icon"
      style={{
        width: 29,
        height: 29,
        marginRight: 8,
      }}
    />

    Exportar PDF
  </Button>

  {/* EXCEL */}
  <Button
    onClick={exportarExcel}
    disabled={!rows.length || !!errorFecha}
    sx={{
      border: "1px solid #2e7d32",
      color: "#2e7d32",
      borderRadius: "10px",
      px: 2,
      py: 1,
      textTransform: "none",
      fontWeight: 600,

      "&:hover": {
        background: "rgba(46,125,50,0.08)",
      },
    }}
  >
    <img
      src="https://cdn-icons-png.flaticon.com/512/732/732220.png"
      alt="Excel Icon"
      style={{
        width: 24,
        height: 24,
        marginRight: 8,
      }}
    />

    Exportar Excel
  </Button>

      </Box>
      <Box
  sx={{
    display: "flex",
    gap: 1,
    mb: 2,
  }}
>
</Box>

      {/* ERROR */}
      {errorFecha && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorFecha}
        </Alert>
      )}

      {/* DATAGRID */}
      <Box
        sx={{
          "& .MuiDataGrid-root": {
            border: "0.5px solid rgba(128,128,128,0.2)",
            borderRadius: "16px",
          },

          "& .MuiDataGrid-columnHeaders": {
            background: "rgba(128,128,128,0.04)",
            borderBottom: "0.5px solid rgba(128,128,128,0.15)",
            fontSize: "10px",
            fontWeight: 700,
            letterSpacing: "0.07em",
            textTransform: "uppercase",
          },
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(row) => `${row.id_asignacion}`}
          loading={loading}
          rowHeight={80}
          autoHeight
          disableRowSelectionOnClick
          pageSizeOptions={[10, 25, 50]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          localeText={{
            noRowsLabel: errorFecha
              ? "Rango de fechas inválido"
              : "Sin registros",
          }}
        />
      </Box>
    </Box>
  );
};


export default HistorialAsignacionU;
